var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 16,
    viewBox: "0 0 72 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.7071 8.67732C72.0976 8.28679 72.0976 7.65363 71.7071 7.2631L65.3431 0.899141C64.9526 0.508617 64.3195 0.508617 63.9289 0.899141C63.5384 1.28967 63.5384 1.92283 63.9289 2.31336L69.5858 7.97021L63.9289 13.6271C63.5384 14.0176 63.5384 14.6508 63.9289 15.0413C64.3195 15.4318 64.9526 15.4318 65.3431 15.0413L71.7071 8.67732ZM8.75098e-08 8.97021L71 8.97021L71 6.97021L-8.75098e-08 6.97021L8.75098e-08 8.97021Z",
    fill: "#F9F5EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/Arrow 1.dd5ca2959edeaa850d36e0ec195f6716.svg";
export { ForwardRef as ReactComponent };